import { ConstantsResponseBoxDto } from "../../../hirings/new-hiring/common/required-documentation/required-doc-data.dto";
import { validateFields } from "../components/assets";
import { FormValues } from "../hooks/hooks.types";
import { FormatedSupplementDoc } from "../utils.type";

export const validateUnsubscriptionData = (
  values: FormValues,
  supplementDocs: FormatedSupplementDoc[]
) => {
  const { errors } = validateFields(values, unsubscriptionRules(supplementDocs));
  const hasValidation = !errors.documents;
  return { errors, hasValidation };
};

export const unsubscriptionRules = (supplementDocs: FormatedSupplementDoc[]) => {
  const requiredDocs = supplementDocs.filter((doc) => doc.required);

  return {
    documents: (documents: { uploadDocuments: ConstantsResponseBoxDto[] }) => {
      let error = "";
      for (const doc of requiredDocs) {
        if (!documents.uploadDocuments.some((uploadDoc) => uploadDoc.type === doc.value)) {
          error = `${error ? error + " - " : ""}${doc.label}`;
        }
      }
      return error;
    },
  };
};
